import * as React from 'react';
import { Box } from '@mui/material';
import { ColorRing } from 'react-loader-spinner';

export default function Loader() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative'
      }}
    >
      <ColorRing
        visible={true}
        height="100"
        width="100"
        ariaLabel="blocks-loading"
        wrapperStyle={{ position: 'relative' }}
        wrapperClass="blocks-wrapper"
        colors={['#0492D4','#0492D4','#0492D4','#0492D4','#0492D4','#0492D4','#0492D4','#0492D4']}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <img
          src="/img/favicon.ico"
          alt="logo"
          style={{ maxWidth: '100px' }}
        />
      </Box>
    </Box>
  );
};
